import Accordion from './Accordion';
import Alert from './Alert';
import AppBar from './AppBar';
import Autocomplete from './Autocomplete';
import Avatar from './Avatar';
import Badge from './Badge';
import BottomNavigation from './BottomNavigation';
import Breadcrumbs from './Breadcrumbs';
import Button from './Button';
import Card from './Card';
import Checkbox from './Checkbox';
import Chip from './Chip';
import Container from './Container';
import Dialog from './Dialog';
import Divider from './Divider';
import IconButton from './IconButton';
import List from './List';
import Menu from './Menu';
import Progress from './Progress';
import Rating from './Rating';
import Slider from './Slider';
import Table from './Table';
import Tabs from './Tabs';
import TextField from './TextField';
import Toolbar from './Toolbar';
import Tooltip from './Tooltip';
import Typography from './Typography';
import type { ThemeOptions } from '@mui/material';

export const components: ThemeOptions['components'] = {
  ...Accordion,
  ...Alert,
  ...AppBar,
  ...Autocomplete,
  ...Avatar,
  ...Badge,
  ...BottomNavigation,
  ...Breadcrumbs,
  ...Button,
  ...Card,
  ...Checkbox,
  ...Chip,
  ...Container,
  ...Dialog,
  ...Divider,
  ...IconButton,
  ...List,
  ...Menu,
  ...Progress,
  ...Rating,
  ...Slider,
  ...Table,
  ...Tabs,
  ...TextField,
  ...Toolbar,
  ...Tooltip,
  ...Typography,
};
